// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCourses-cls1_yLb","cls2":"NewCourses-cls2_1Tz NewCourses-cls1_yLb"};